module.exports = __webpack_public_path__ + "img/logo.65d88da0.png";